"use client";

import { c as _c } from "react/compiler-runtime";
import { useSeizeConnectContext } from "@/components/auth/SeizeConnectContext";
import { faRightLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useRef } from "react";
import { useTransfer } from "./TransferState";
export default function TransferToggle() {
  const $ = _c(17);
  const t = useTransfer();
  const {
    isConnected,
    seizeConnect,
    seizeConnectOpen
  } = useSeizeConnectContext();
  const buttonRef = useRef(null);
  const {
    enabled: transferEnabled,
    setEnabled: setTransferEnabled,
    clear: clearTransfer
  } = t;
  const wantTransferAfterConnect = useRef(false);
  let t0;
  let t1;
  if ($[0] !== isConnected || $[1] !== seizeConnectOpen || $[2] !== setTransferEnabled) {
    t0 = () => {
      if (isConnected && wantTransferAfterConnect.current) {
        setTransferEnabled(true);
        wantTransferAfterConnect.current = false;
      }
      if (!isConnected && !seizeConnectOpen && wantTransferAfterConnect.current) {
        wantTransferAfterConnect.current = false;
      }
    };
    t1 = [isConnected, seizeConnectOpen, setTransferEnabled];
    $[0] = isConnected;
    $[1] = seizeConnectOpen;
    $[2] = setTransferEnabled;
    $[3] = t0;
    $[4] = t1;
  } else {
    t0 = $[3];
    t1 = $[4];
  }
  useEffect(t0, t1);
  let t2;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      if (!buttonRef.current) {
        return;
      }
      const rect = buttonRef.current.getBoundingClientRect();
      const absoluteY = window.scrollY + rect.top - 10;
      window.scrollTo({
        top: absoluteY,
        behavior: "smooth"
      });
    };
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const scrollToButton = t2;
  let t3;
  if ($[6] !== clearTransfer || $[7] !== isConnected || $[8] !== seizeConnect || $[9] !== setTransferEnabled || $[10] !== transferEnabled) {
    t3 = () => {
      if (!isConnected) {
        wantTransferAfterConnect.current = true;
        seizeConnect();
        return;
      }
      if (transferEnabled) {
        clearTransfer();
        setTransferEnabled(false);
      } else {
        scrollToButton();
        setTransferEnabled(true);
      }
    };
    $[6] = clearTransfer;
    $[7] = isConnected;
    $[8] = seizeConnect;
    $[9] = setTransferEnabled;
    $[10] = transferEnabled;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = ["tw-inline-flex tw-items-center tw-gap-x-2 tw-rounded-lg tw-border-0 tw-ring-1 tw-ring-inset tw-ring-white hover:tw-ring-iron-300 tw-shadow-sm tw-px-3.5 tw-py-2.5 tw-font-semibold tw-text-sm", "tw-text-iron-800 tw-bg-iron-200 hover:tw-bg-iron-300 tw-whitespace-nowrap tw-transition tw-duration-300 tw-ease-out"];
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  const t5 = t.enabled ? "Exit Transfer" : "Transfer";
  let t6;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <FontAwesomeIcon icon={faRightLeft} />;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t3 || $[15] !== t5) {
    t7 = <button ref={buttonRef} type="button" onClick={t3} className={t4.join(" ")}>{t5}{t6}</button>;
    $[14] = t3;
    $[15] = t5;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  return t7;
}